<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - ROOT大师</div>
        <product-menu now="vroot" />
        <div class="v100 bigimg mt20">
            <img alt="ROOT大师" src="@/assets/images/vroot_0120.jpg" />
            <div class="brand">
				<img src="@/assets/images/rootds.jpg" alt="ROOT大师" height="75" width="121" />
			</div>
            <h1 style="display:block;position:absolute;left:-5999px">ROOT大师</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="ROOT大师，成功率超高的ROOT工具" class="fl" src="@/assets/images/Ray10.jpg" />
                <dt class="fr">一键ROOT</dt>
                <dd class="fr">
                    大师在手，ROOT您有！支持机型超多、成功率超高的一键ROOT工具</dd>
            </dl>
            <dl>
                <img alt="ROOT大师，支持超多机型的ROOT工具" class="fr" src="@/assets/images/Ray11.jpg" />
                <dt class="fl">全面支持</dt>
                <dd class="fl">
                    集成多款ROOT引擎，多平台支持，不断钻研新技术ROOT更多机型</dd>
            </dl>
            <dl>
                <img alt="ROOT大师，功能超强大的ROOT工具" class="fl" src="@/assets/images/Ray12.jpg" />
                <dt class="fr">系统管理</dt>
                <dd class="fr">
                    
自带授权管理，强力卸载内置垃圾软件，一键优化管理您的手机</dd>
            </dl>
            <dl>
                <img alt="ROOT大师，功能超强大的ROOT工具" class="fr" src="@/assets/images/Ray13.jpg" />
                <dt class="fl">贴心服务</dt>
                <dd class="fl">
                    主题美化、海量ROM、应用游戏、一键刷机，让您成为手机真正的MASTER</dd>
            </dl>
        </div>
    </div>


</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "vroot",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/vroot.vue